import {
  isSupportedLocale,
  normalizeLocale,
  type SupportedLocale,
} from '@/i18n/config';
import { resolveBrowserLocale } from './browser-locale';

type LocalePreferenceSources = {
  headerLocale: string | null | undefined;
  profileLocale: string | null | undefined;
  cookieLocale: string | null | undefined;
  acceptLanguage?: string | null;
};

export function resolveLocalePreference({
  headerLocale,
  profileLocale,
  cookieLocale,
  acceptLanguage,
}: LocalePreferenceSources): SupportedLocale {
  if (headerLocale && isSupportedLocale(headerLocale)) {
    return headerLocale;
  }

  if (typeof profileLocale === 'string') {
    return normalizeLocale(profileLocale);
  }

  if (cookieLocale) {
    return normalizeLocale(cookieLocale);
  }

  return resolveBrowserLocale(acceptLanguage);
}

type LocaleSelectionPersistenceArgs = {
  isAuthenticated: boolean;
  profileTimezone: string | null | undefined;
  browserTimezone: string | null | undefined;
};

export function getLocaleSelectionPersistence({
  isAuthenticated,
  profileTimezone,
  browserTimezone,
}: LocaleSelectionPersistenceArgs):
  | { mode: 'pending-signup' }
  | { mode: 'profile'; timezone: string } {
  if (!isAuthenticated) {
    return { mode: 'pending-signup' };
  }

  return {
    mode: 'profile',
    timezone: profileTimezone?.trim() || browserTimezone?.trim() || 'UTC',
  };
}

export function shouldSyncPendingLocale(
  pendingLocale: string | null | undefined,
  profileLocale: string | null | undefined
): boolean {
  return Boolean(
    pendingLocale &&
      typeof profileLocale === 'string' &&
      normalizeLocale(pendingLocale) !== normalizeLocale(profileLocale)
  );
}
